<template>
  <div>
    <el-row>
      <div>
        <div style="float: left; margin: 10px 0px 10px 0px;">
          <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Group Data By:</label>
          <el-select :default-first-option="true" style="width: 170px" v-model="localQueryGrouping" @input="localQueryDrillDown = ''" placeholder="Group Data by" filterable
            @change="setVuexState">
            <el-option v-for="item in queryDropdown" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <div style="float: left; margin: 10px 0px 10px 10px;">
          <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">DrillDown:</label>
          <el-select :default-first-option="true" style="width: 170px" v-model="localQueryDrillDown" placeholder="DrillDown" filterable clearable @change="setVuexState">
            <el-option v-for="item in queryDropdown.filter(x => x.key !== localQueryGrouping)" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </div>
      </div>
    </el-row>
    <el-table id="codingLargeStat1" :data="getQueryData()" empty-text="No Queries Available" :fit="true" :height="isModal ? null : '232'" show-summary
      :summary-method="getSummary">
      <el-table-column prop="title" label="Grouping" id="headerTitle" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column type="expand" id="headerExpand">
        <template slot-scope="props">
          <el-table id="queryDrillDownTable" :data="getDrillDownForRow(props.row, localQueryDrillDown)" empty-text="No DrillDown Selected" :fit="true">
            <el-table-column prop="title" id="subTitle" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="affectedDRG" align="center">
            </el-table-column>
            <el-table-column prop="soi" align="center">
            </el-table-column>
            <el-table-column prop="rom" align="center">
            </el-table-column>
            <el-table-column prop="ccorMcc" align="center">
            </el-table-column>
            <el-table-column prop="clinicalValidity" align="center">
            </el-table-column>
            <el-table-column prop="totalQueries" align="center">
            </el-table-column>
            <el-table-column prop="totalRecords" align="center">
              <template slot-scope="scope">
                <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${props.row.title}-${scope.row.title} Records`, scope.row.accounts, $event)">
                  {{scope.row.totalRecords}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="affectedDRG" sortable label="Affects DRG?" align="center">
      </el-table-column>
      <el-table-column prop="soi" sortable label="SOI" align="center">
      </el-table-column>
      <el-table-column prop="rom" sortable label="ROM" align="center">
      </el-table-column>
      <el-table-column prop="ccorMcc" sortable label="CC/MCC" align="center">
      </el-table-column>
      <el-table-column prop="clinicalValidity" sortable label="Clinical Validity" align="center">
      </el-table-column>
      <el-table-column prop="totalQueries" sortable label="Total Queries" align="center">
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Records" sortable align="center">
        <template slot-scope="scope">
          <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${scope.row.title} Records`, scope.row.accounts, $event)">
            {{scope.row.totalRecords}}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import money from '@/mixins/money'
  import { mapState, mapMutations } from 'vuex'

  export default {
    props: ['dashboardData'],
    mixins: [money],
    components: {
    },
    data: function () {
      return {
        localQueryGrouping: 'Category',
        localQueryDrillDown: 'Physician',
        queryDropdown: [{ key: 'Category', value: 'Query Category' }, { key: 'CDI Staff', value: 'CDI Staff' }, { key: 'Consultant', value: 'Consultant' }, { key: 'Physician', value: 'Physician' }, { key: 'Service', value: 'Service' }]
      }
    },
    name: 'QueryListTable',
    methods: {
      ...mapMutations('dashboard', ['SET_QUERY_LIST_FIELDS']),
      patientTypeGetDrillDownForRow(row) {
        return row.consultants.length ? row.consultants : []
      },
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      getQueryData() {
        switch (this.localQueryGrouping) {
          case 'Category':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[3].data : []
          case 'Physician':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[4].data : []
          case 'CDI Staff':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[5].data : []
          case 'Service':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[6].data : []
          case 'Consultant':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[7].data : []
        }
      },
      getDrillDownForRow(row, type) {
        switch (type) {
          case 'Category':
            return row.categories
          case 'Physician':
            return row.physicians
          case 'CDI Staff':
            return row.cdiStaff
          case 'Service':
            return row.service
          case 'Consultant':
            return row.consultants
        }
      },
      emitDetailsEvent(title, accounts, e) {
        this.$emit('detailsClick', {
          title: title,
          accounts: accounts,
          e: e
        })
      },
      setVuexState() {
        if (!this.isModal) {
          this.SET_QUERY_LIST_FIELDS({ queryGrouping: this.localQueryGrouping, queryDrillDown: this.localQueryDrillDown })
        }
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const affectedDRG = this.totalSummary('affectedDRG', param.data)
        const soi = this.totalSummary('soi', param.data)
        const rom = this.totalSummary('rom', param.data)
        const cc = this.totalSummary('ccorMcc', param.data)
        const clinicalValidity = this.totalSummary('clinicalValidity', param.data)
        const totalQueries = this.totalSummary('totalQueries', param.data)
        const totalRecords = this.totalSummary('totalRecords', param.data)

        return [null, null, cc, affectedDRG, soi, rom, clinicalValidity, totalQueries, totalRecords]
      }
    },
    created: function () {
      if (this.isModal) {
        this.localQueryDrillDown = this.queryDrillDown
        this.localQueryGrouping = this.queryGrouping
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        const footerRow = document.querySelectorAll('#codingLargeStat1 table.el-table__footer td')
        const td = footerRow[footerRow.length - 1]
        td.classList.add('dottedUnderline')
        td.addEventListener('click', (e) => {
          const allAccounts = this.dashboardData[0].largeStats[3].data.map(x => x.accounts).join(',')
          this.emitDetailsEvent('All Queried Records', allAccounts, e)
        })
      })
    },
    computed: {
      ...mapState('dashboard/', ['queryDrillDown', 'queryGrouping']),
      isModal() {
        return this.$parent.modal
      }
    },
    watch: {
      queryDrillDown: function () {
        if (this.isModal) {
          this.localQueryDrillDown = this.queryDrillDown
        }
      },
      queryGrouping: function () {
        if (this.isModal) {
          this.localQueryGrouping = this.queryGrouping
        }
      }
    }
  }
</script>

<style scoped>
  >>>.el-table__footer-wrapper {
    width: 100%;
  }

  >>>.el-table__empty-block {
    width: 100% !important;
  }

  >>>.el-table__footer {
    width: unset !important;
  }
</style>
